export var SortMode;
(function (SortMode) {
    SortMode["TIME"] = "Time";
    SortMode["PRIORITY"] = "Priority";
    SortMode["EXPIRATION"] = "Expiration";
    SortMode["MESSAGE_TYPE"] = "MessageType";
})(SortMode || (SortMode = {}));
export function toSortMode(value) {
    return Object.values(SortMode).includes(value) ? value : undefined;
}
